import { render } from "./SupplierCommission.vue?vue&type=template&id=a4c3b610"
import script from "./SupplierCommission.vue?vue&type=script&lang=js"
export * from "./SupplierCommission.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__